import { DesignSystem } from '@microsoft/fast-foundation';
export const DEFAULT_PREFIX = 'chameleon';
export const provideChameleonDesignSystem = ({ prefix = DEFAULT_PREFIX, node, } = {}) => {
    return DesignSystem.getOrCreate(node).withPrefix(prefix);
};
